export enum LotTypeEnum{
    Carding = 'Carding',
    Dressing = 'Dressing',
    Blowing = 'Blowing',
    Bale = 'Bale'
}